import { SavePayload } from "../../types/save.types";
import { ApiProcedureRow } from "../../types/order.types";

// O backend guarda o que a IA sugeriu (modelo) ao lado do que o médico validou,
// e como escolheu (pacote e índice) para restaurar a tela ao reabrir o pedido.
export const proceduresPayload = (
  timestamp: string,
  suggested: string[][],
  validated: ApiProcedureRow[],
  proceduresProps: NonNullable<SavePayload["proceduresProps"]>
): SavePayload => ({
  timestamp,
  procedimentos_modelo: suggested.map((row) => row.join(" ")).join(", "),
  procedimentos_validados: validated.map((r) => `${r.code} ${r.description} ${r.quantity}`).join(", "),
  proceduresProps,
});
